export class AssetResolver {
  constructor(manifest = { assets: {} }) {
    this.manifest = manifest;
  }

  resolve(kind, id, role, overrides = {}) {
    const override = overrides[role];
    if (override) {
      return this.#entry(override);
    }
    return this.#entry(`${kind}/${id}/${role}`);
  }

  portrait(opponent) {
    return this.resolve(
      "opponent",
      opponent.id,
      "portrait",
      opponent.assetOverrides,
    );
  }
  video(opponent) {
    return this.resolve(
      "opponent",
      opponent.id,
      "idle_video",
      opponent.assetOverrides,
    );
  }

  music(opponent, currentUrl = null) {
    const direct = opponent.bgm
      ? this.#entry(`audio/music/${opponent.bgm}/default`)
      : this.resolve("opponent", opponent.id, "music", opponent.assetOverrides);
    return (
      direct ??
      (currentUrl ? { url: currentUrl } : null) ??
      this.#entry("audio/music/base_bgm/default")
    );
  }

  ui(role) {
    return this.#entry(`ui/system/${role}`);
  }
  piece(setId, color, type) {
    return this.#entry(
      `piece_set/${setId}/${color === "w" ? "white" : "black"}_${{ k: "king", q: "queen", r: "rook", b: "bishop", n: "knight", p: "pawn" }[type]}`,
    );
  }
  pieceModel(setId) {
    return this.#entry(`piece_set/${setId}/model`);
  }
  board(themeId, role) {
    return this.#entry(`board_theme/${themeId}/${role}`);
  }

  #entry(key) {
    const entry = this.manifest.assets?.[key];
    if (
      !entry ||
      typeof entry.url !== "string" ||
      !entry.url.startsWith("./generated/") ||
      entry.url.includes("..")
    ) {
      return null;
    }
    return entry;
  }
}
